import { render, staticRenderFns } from "./InputView.vue?vue&type=template&id=32dbfe89&scoped=true&"
import script from "./InputView.vue?vue&type=script&lang=js&"
export * from "./InputView.vue?vue&type=script&lang=js&"
import style0 from "./InputView.vue?vue&type=style&index=0&id=32dbfe89&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dbfe89",
  null
  
)

export default component.exports